<template>
  <div class="col-12 col-sm-12 resultados2021">
      <div class="row pt-3">
        <div class="col-12 col-sm-12 col-md-4 d-md-block d-none mapa-resultados-wrapper">
          <candidatosResultados :candidatos="filteredData" />
        </div>
        <div class="col-12 col-sm-12 col-md-8 mapa-resultados-wrapper">
          <MapaDepartamentos :lista_candidatos="filteredData" />
        </div>
        <div class="col-12 col-sm-12 d-block d-md-none mapa-resultados-wrapper">
          <candidatosResultados :candidatos="filteredData" />
        </div>
      </div>
  </div>    
</template>

<script>

import { mapState } from 'vuex'
import candidatosResultados from '../components/candidatosResultados.vue'
import MapaDepartamentos from '../components/MapaDepartamentos.vue'
import { filter } from 'lodash'

export default {
  name: 'MapaEleciones',
  props: {
    encuestas: Array
  },
  components: {
    MapaDepartamentos,
    candidatosResultados
  },
  created () {
    this.$store.dispatch('candidatos/getAllCandidatos')
  },
  methods: {
    getImageCandidate(c) {
      try {
        return require(`../assets/candidatos/${c}.png`)
      } catch (error) {
        return require(`../assets/candidatos/blanco-viciado.png`)
      }
    },
    getImagePartido(c) {
      try {
        return require(`../assets/partidos/${c}.png`) 
      } catch (error) {
        return require(`../assets/partidos/blanco-viciado.png`)
      }
    }
  },
  computed: {
    ...mapState({
      candidatos: state => state.candidatos.todos,
      regionSeleccionada: state => state.candidatos.regionSeleccionada,
      partidoSeleccionado: state => state.candidatos.partidoSeleccionado,
    }),
    data() {
      return require('../data/departamentos_primera_vuelta.json')
    },
    filteredData() {

      if(this.regionSeleccionada.region != 'NACIONAL' && this.partidoSeleccionado.partido_id == 'TODOS') {

        return this.regionSeleccionada.candidatos
      }

      if(this.regionSeleccionada.region == 'NACIONAL' && this.partidoSeleccionado.partido_id != 'TODOS') {

        return filter(this.candidatos, c => c.partido_id == this.partidoSeleccionado.partido_id)
      }

      return filter(this.candidatos, c => c.candidato_id != "")
    }     
  }
}

</script>


